import { createFileRoute, redirect, Navigate } from '@tanstack/react-router';
import { checkRoutePermission } from '@/components/Auth/checkUserPermissions.ts';
import { getDefaultView } from '@/utils/viewHelpers';
import { DocumentHead } from '@/components/core/DocumentHead';

export const Route = createFileRoute(
  '/$tenantId/_layout/students/transportation/',
)({
  component: StudentTransportationRedirect,
  beforeLoad: ({ params }) => {
    const hasPermission = checkRoutePermission({
      permission: 'organization:viewer',
    });
    if (!hasPermission) {
      throw redirect({ to: '/$tenantId', params });
    }
  },
});

function StudentTransportationRedirect() {
  const { tenantId } = Route.useParams();
  const view = getDefaultView('students/transportation');

  return (
    <>
      <DocumentHead
        titleKey="page.students.transportation.title"
        descriptionKey="page.students.transportation.description"
        resetOnUnmount={false}
      />
      <Navigate
        to="/$tenantId/students/transportation/$view"
        params={{ tenantId, view }}
        replace
      />
    </>
  );
}
